module.exports = __webpack_public_path__ + "static/media/white-close.e0078247.svg";